import React, { Fragment } from 'react'

import { connect } from 'react-redux'
import { compose } from 'recompose'

import Helmet from 'react-helmet'
// import Content from './Content'

import { connectToNote } from '@slite/editor'
import { selectors as NotesSelectors } from 'data/notes'

import { TEMPLATE_VIEW } from 'components/viewNames'
import syncNote from '../../Notes/dataSync'
import providesUserPresence from '../../Notes/dataSync/providesUserPresence'

import { NotePanelLoading } from 'components/Layout/AppLoading'
import NoteTitle from 'components/Notes/Title'

import { setActiveModal } from 'data/ui/actions'

import NoteView from 'components/Layout/NoteView'
import RichTextEditor from 'screens/NotesShow/RichTextEditor'

import { Provider as SharedEventBusContextProvider } from 'contexts/sharedEventBus'

function TemplatesView({ templateId, templateTitle, showLoadingPlaceholder }) {
  const titleInputRef = React.useRef()
  const [editorRef, setEditorRef] = React.useState(null)

  const focusEditor = React.useCallback(
    ({ at = 0, insertLine = false } = {}) => {
      if (editorRef && editorRef.focusFirstLine) {
        editorRef.focusFirstLine(at, { insertLine })
      }
    },
    [editorRef]
  )

  const focusNoteTitleInput = React.useCallback(
    ({ at = 0 }) => {
      const input = titleInputRef.current
      if (input) {
        input.focus()
        if (input.setSelectionRange && at >= 0) {
          requestAnimationFrame(() => input.setSelectionRange(at, at))
        }
      }
    },
    [titleInputRef]
  )

  if (showLoadingPlaceholder) {
    return <NotePanelLoading />
  }

  return (
    <Fragment>
      <Helmet title={`${templateTitle || 'untitled'} - Templates`} />
      <SharedEventBusContextProvider>
        <NoteView>
          <NoteTitle
            ref={titleInputRef}
            noteId={templateId}
            noteTitle={templateTitle}
            focusNext={focusEditor}
          />
          <RichTextEditor
            noteId={templateId}
            noteTitle={templateTitle}
            userCanEdit={true}
            titlePlaceholder="Give your template a title"
            onEditorRef={setEditorRef}
            focusNoteTitleInput={focusNoteTitleInput}
          />
        </NoteView>
      </SharedEventBusContextProvider>
    </Fragment>
  )
}

const mapStateToProps = (state, { templateId }) => {
  const template = NotesSelectors.getNote(state, templateId)
  const templateTitle = template && template.get('title')

  return {
    showLoadingPlaceholder: !template,
    templateId,
    templateTitle,
  }
}

const mapDispatchToProps = {
  setActiveModal,
}

const ConnectedTemplateView = compose(
  connectToNote(({ templateId }) => ({ noteId: templateId })),
  providesUserPresence({
    mapPropsToVariables: ({ templateId }) => ({ noteId: templateId }),
  }),
  syncNote({
    viewName: TEMPLATE_VIEW,
    mapPropsToVariables: ({ templateId }) => ({
      noteId: templateId,
      track: false,
    }),
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(TemplatesView)

export default ConnectedTemplateView
